import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'submission-details',
    templateUrl: './submission-details.component.html',
    styleUrls: [ './submission-details.component.scss' ]
})
export class SubmissionDetailsComponent implements OnInit {

    constructor() {
    }

    refreshValue() {
    }

    ngOnInit() {
    }
}
